import { apiRequest } from './client';

export function fetchAnalytics(token, { days = 30 } = {}) {
  const query = new URLSearchParams({ days: String(days) });
  return apiRequest(`/admin/analytics?${query.toString()}`, token);
}

export function fetchSalesOverview(token, { date = 'today', marketplace = 'ALL', fulfillmentChannel = 'ALL' } = {}) {
  const query = new URLSearchParams();
  if (date) query.set('date', String(date));
  if (marketplace) query.set('marketplace', String(marketplace));
  if (fulfillmentChannel) query.set('fulfillmentChannel', String(fulfillmentChannel));
  return apiRequest(`/admin/sales-overview?${query.toString()}`, token);
}
